import { Component, HostListener                   } from '@angular/core';
import { UserService                 } from '../../providers/user.service';
import { IGenericListResponse        } from '../../providers/generic.service';
import { Observable                  } from 'rxjs/Observable';
import { Sort                        } from '@angular/material';
import {
  IonicPage,
  NavController,
  ToastController                    } from 'ionic-angular';
import { IUser                       } from "../../../typings/timetracker/timetracker";
import { pickBy, isNil, merge        } from 'lodash';
import { fadeInOut                   } from "../../utils/animations";

export interface IField {
  label:        string;
  field:        string;
  width:        string;
  hideOnMobile: boolean;
}

/**
 * Generated class for the UsersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
  animations: [fadeInOut]
})
export class UsersPage {

  public limit = 15;
  public skip = 0;
  public total = 0;
  public selectedPage = 1;
  public sortField = 'employee_nr';
  public sortDirection = 'ASC';
  public _fields = [];
  public currentPage: number;
  public currentUser: IUser;

  public fields: IField[];
  public list$: Observable<IGenericListResponse<IUser>>;

  /**
   * @param {number} page The page number to switch to
   */
  public paginate( page: number ) {
    console.log( '[M-CATCH] Paginate', page );
    const newSkip = (page * this.limit) - this.limit;

    if ( this.skip !== newSkip ) {
      this.selectedPage = (newSkip / this.limit) + 1;
      this.skip = newSkip;

      // Dispatch a new API call
      //
      this.getList( this.limit, this.skip,this.sortField, this.sortDirection, this.selectedPage );
    }
  }

  /**
   * @param {Sort} $event Contains event field and direction information
   */
  public changeSortDirection( $event: Sort ) {
    console.log( '[M-CATCH] Change sort direction', $event );
    this.skip = 0;
    this.selectedPage = 1;
    this.sortDirection = $event.direction.toUpperCase();
    this.sortField = $event.active;

    // Dispatch a new API call
    //
    this.getList( this.limit, this.skip,this.sortField, this.sortDirection, this.selectedPage );
  }

  public getList( limit: number, skip: number, sortField: string, sortDirection: string, currentPage: number ) {
    this.currentPage = currentPage;
    this.$userService.dispatchUserFetchAll( limit, skip, sortField, sortDirection );
  }

  public getDetails( user: IUser ) {
    console.log( '[M-CATCH] Get Details', user.id );
    this.$userService.selectUserByIdFetch( user.id ).take( 1 ).subscribe( ( currentUser ) => {
      if ( !this.currentUser || this.currentUser && this.currentUser.id !== user.id ) {
        console.log( '[USERS] Show details for other user', currentUser );
        this.currentUser = user;
      }
    } );
  }

  public updateUser(userFields: Partial<IUser>): void {

    const unfilteredUpdatedUser = merge(this.currentUser, userFields);

    /** Updated user without null values */
    const filteredUpdatedUser = <Partial<IUser>>pickBy(unfilteredUpdatedUser, val => !isNil(val));

    this.$userService.dispatchUserUpdate(filteredUpdatedUser.id, filteredUpdatedUser)
      .take(1)
      .subscribe( user => {
        this.toastCtrl.create({
          message: `Gegevens voor ${user.fullname} bijgewerkt`,
          duration: 3000
        }).present();
      });
  }

  @HostListener('document:keyup.Escape', ['$event']) closeDetails( $event: MouseEvent | KeyboardEvent ) {

    if ( $event instanceof MouseEvent ) {
      $event.stopPropagation();
    }

    this.currentUser = null;
  }

  constructor( public navCtrl: NavController, private $userService: UserService, private toastCtrl: ToastController ) {
    this.list$ = this.$userService.selectUserFetchAll();
    this.fields = [
      {
        label: 'Nummer',
        field: 'employee_nr',
        width: '1%',
        hideOnMobile: false
      },
      {
        label: 'Naam',
        field: 'fullname',
        width: '35%',
        hideOnMobile: false
      },
      {
        label: 'Emailadres',
        field: 'email',
        width: '30%',
        hideOnMobile: false
      },
      {
        label: 'Laatst gezien',
        field: 'last_seen',
        width: '15%',
        hideOnMobile: false
      },
      {
        label: 'Aangemaakt',
        field: 'created_at',
        width: '15%',
        hideOnMobile: true
      }
    ];
    this.getList( this.limit, this.skip,this.sortField, this.sortDirection, this.selectedPage );
  }
}


// WEBPACK FOOTER //
// ./src/pages/users/users.ts